<template>
  <div id="addstep">
    <div class="container mb50">
      <p class="sub-title">Artwork Complete</p>
      <div ref="printMe" class="printbox">
        <PreviewPanel :artwork="this.$store.state.artwork" />
      </div>
    </div>
    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="edit()">
        EDIT
      </span>
      <span class="orange click inlineb w10" @click="next()">
        NEXT
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import jsPDF from "jspdf";

import PreviewPanel from "./PreviewPanel";

export default {
  name: "AlbaComplete",
  components: {
    PreviewPanel
  },
  data() {
    return {};
  },

  methods: {
    async download() {
      const el = this.$refs.printMe;
      const options = {
        type: "dataURL"
      };
      const output = await this.$html2canvas(el, options);
      var doc = new jsPDF("landscape", "cm");
      doc.addImage(output, "JPEG", 0, 0, 29.7, 21);
      doc.save(this.$store.state.artwork.name + ".pdf");
    },
    next() {
      this.$router.push({path: '/artwork/'+this.$store.state.artwork._id});
    },
    edit() {
      this.$router.push({path: '/collection/engraving/'+this.$store.state.artwork._id});
    }
  },

  created: function() {
    this.$parent.headerB();
    this.$parent.footerB();
    this.$parent.footerW();
  }
};
</script>

<style lang="css" scoped>
.nav-footer{
  border-top:1px solid #ccc;
}
</style>
